/* eslint-disable react/prop-types */
// Imports
import React from "react";
import { BookmarkButton } from "../../RecBookmarkButton/jsx/index.jsx";
import { useQuiz } from "src/contexts/QuizContext.js";
import { getNormalisedUrl, gtmPush } from "../../utils/helpers";

const RecCard = ({
    id,
    name,
    thumbnail,
    summary,
    url,
    tags,
    recommended = true,
    can_bookmark,
}) => {
    const { windowWidth } = useQuiz();

    // filter empty tags
    const tagsArray = [...tags].filter(Boolean);

    const bookmarkData = {
        id,
        name,
        summary,
        url,
        tags,
        thumbnail,
        can_bookmark,
        category: tagsArray.length > 0 ? tagsArray[0] : "", // Use first tag as category
        tagline: "Read more", // Default tagline since it's not provided
    };

    const handleLinkClick = () => {
        // Get the card title text
        const cardText = name || "Read recommendation";

        gtmPush({
            event: "recommendation_interaction",
            interaction_type: "click",
            component_name: "rec-card",
            click_text: cardText,
            click_url: getNormalisedUrl(url),
        });
    };

    return (
        <>
            <div className="rec-card">
                <div className="rec-card__details">
                    <div className="rec-card__pills-wrapper">
                        <div className="rec-card__pills">
                            {recommended && (
                                <span className="pills pills--rec">
                                    Recommendation
                                </span>
                            )}
                            {tagsArray.map((tags, index) => (
                                <span key={index} className="pills">
                                    {tags}
                                </span>
                            ))}
                        </div>
                        {can_bookmark && <BookmarkButton data={bookmarkData} />}
                    </div>
                    <div className="rec-card__content">
                        {name && (
                            <h3
                                className="rec-card__title"
                                dangerouslySetInnerHTML={{
                                    __html: name.replace(
                                        /(<? *script)/gi,
                                        "illegalscript",
                                    ),
                                }}
                            ></h3>
                        )}
                        {summary && (
                            <p
                                className="rec-card__desc"
                                dangerouslySetInnerHTML={{
                                    __html: summary.replace(
                                        /(<? *script)/gi,
                                        "illegalscript",
                                    ),
                                }}
                            ></p>
                        )}
                        {url && (
                            <a
                                className="rec-card__link"
                                href={url}
                                rel="noreferrer"
                                target="_blank"
                                aria-label={`Read recommendation - ${name}`}
                                onClick={handleLinkClick}
                            >
                                Read {windowWidth > 997 ? "recommendation" : ""}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecCard;
